import { all, put, select, takeEvery } from 'redux-saga/effects';
import {
  GET_EMAIL_TEMPLATE,
  setEmailTemplate,
  setEmailTemplateStatus
} from './emailTemplate';
import { getEmailTemplateApi } from '../../../helpers/advertiserApi';
import { modules } from 'veritone-redux-common';
import { Status } from './campaign/actions';
import { get } from 'lodash';
import { showToast } from './notification';
import constant from '../../../helpers/constant';

const {
  config: { getConfig }
} = modules;

export function* getEmailTemplateSaga() {
  const config = yield select(getConfig);
  yield put(setEmailTemplateStatus(Status.LOADING));
  const res = yield getEmailTemplateApi(config.urlApi);

  if (res && res.error) {
    const toast = {
      message: 'Fail to fetch list of email template',
      action: 'Dismiss',
      type: constant.FAILED
    };
    showToast(toast);
    yield put(setEmailTemplateStatus(Status.ERROR));
  } else {
    const emailTemplateList = get(res, 'data');
    yield put(setEmailTemplate(emailTemplateList));
  }
}

export default function* auth() {
  yield all([takeEvery(GET_EMAIL_TEMPLATE, getEmailTemplateSaga)]);
}
